import React, { useRef } from "react";
import "./home.css";
import Gallery from "../../Components/Gallery/Gallery";
import { motion, useInView } from "framer-motion";
import Footer from "../../Components/Footer/Footer.jsx";
import PunchCard from "../../Assets/punchcard.png";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function Home() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="home-jsx">
        <div className="mobile-logo">
          <img
            src="https://i.imgur.com/1EBXSNB.png"
            alt="Logo"
            className="home-logo-mobile"
          />
        </div>
        <div className="gallery-div">
          <Gallery />
        </div>
        <div className="welcome">
          <h4>WELCOME TO</h4>
          <h1>CAFE VISTA</h1>
          <RevealOnScroll>
            <p>
              Cafe Vista is a women-owned and operated cafe, founded by the
              visionary Balsayat Jorayeva. Located at 527 Monroe Street, this
              beautifully designed and curated haven reflects Balsayat's passion
              and dedication. Every detail, from the carefully selected decor to
              the delicious menu offerings, has been lovingly chosen by Balsayat
              and her team Cafe Vista is a testament to her commitment to
              creating a warm and inviting atmosphere.
            </p>
          </RevealOnScroll>
        </div>
        <div className="twoimg-container">
          <RevealOnScroll>
            <div className="img1-container">
              <img
                src="https://i.imgur.com/wRIbLue.jpeg"
                alt=""
                className="img1-1"
              />
              <a href="/menu" className="view-menu-home">
                VIEW MENUS
              </a>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="img2-container">
              <img
                src="https://i.imgur.com/hNuETFt.jpeg"
                alt=""
                className="img1-1"
              />
              <a href="/locations" className="view-menu-home">
                LOCATIONS
              </a>
            </div>
          </RevealOnScroll>
        </div>
        <RevealOnScroll>
          <div className="image-gallery-2">
            <img
              src="https://i.imgur.com/pdndjKY.jpeg"
              className="images-gallery2"
            />
            <img
              src="https://i.imgur.com/XaBEoHa.jpeg"
              className="images-gallery2"
            />
            <img
              src="https://i.imgur.com/MlGBOw5.jpeg"
              className="images-gallery2"
            />
            <img
              src="https://i.imgur.com/X0CCi3m.jpeg"
              className="images-gallery2"
            />
            <img
              src="https://i.imgur.com/udqOy3o.jpeg"
              className="images-gallery2"
            />
            <img
              src="https://i.imgur.com/cP2gGzU.jpeg"
              className="images-gallery2"
            />
          </div>
          <div className="punch-card">
            <div>
              <img
                src={PunchCard}
                alt="Punch Card"
                className="punch-card-img"
              />
            </div>
            <div className="promote">
              <h1 className="buy10">Buy 10 Drinks and Get 1 Free!</h1>
              <p>
                Grab a punch card on your next visit, and after 10 drink
                purchases from our menu, you'll get 1 free! Any drink, any size.
              </p>
            </div>
          </div>
        </RevealOnScroll>
      </div>
      <Footer />
    </motion.div>
  );
}

export default Home;
